export const fireConfettiFromPopup = (
  container: HTMLElement,
  options: {
    count?: number;
    duration?: number;
    colors?: string[];
    spreadRadius?: number;
  } = {}
) => {
  const {
    count = 420,
    duration = 3900,
    spreadRadius = 1800,
    colors = ['#ff4081', '#00bcd4', '#4caf50', '#ffeb3b', '#ff9800', '#9c27b0', '#03a9f4', '#e91e63']
  } = options;

  // Get popup position
  const rect = container.getBoundingClientRect();
  
  // 4 corners of the popup
  const points = [];

  // 4 CORNERS
  points.push({ x: rect.left, y: rect.top });
  points.push({ x: rect.right, y: rect.top });
  points.push({ x: rect.left, y: rect.bottom });
  points.push({ x: rect.right, y: rect.bottom });

  //  4 SIDE CENTERS
  points.push({ x: rect.left + rect.width / 2, y: rect.top });
  points.push({ x: rect.left + rect.width / 2, y: rect.bottom });
  points.push({ x: rect.left, y: rect.top + rect.height / 2 });
  points.push({ x: rect.right, y: rect.top + rect.height / 2 });

  // 8 INTERMEDIATE POINTS 
  for (let i = 1; i < 16; i++) {
    const t = i / 16;
    // Top edge
    points.push({ x: rect.left + rect.width * t, y: rect.top });
    // Bottom edge
    points.push({ x: rect.left + rect.width * t, y: rect.bottom });
    // Left edge
    points.push({ x: rect.left, y: rect.top + rect.height * t });
    // Right edge
    points.push({ x: rect.right, y: rect.top + rect.height * t });
  }

  //  4 CORNER INTERMEDIATES 
  points.push({ x: rect.left + rect.width * 0.15, y: rect.top + rect.height * 0.15 });
  points.push({ x: rect.right - rect.width * 0.15, y: rect.top + rect.height * 0.15 });
  points.push({ x: rect.left + rect.width * 0.15, y: rect.bottom - rect.height * 0.15 });
  points.push({ x: rect.right - rect.width * 0.15, y: rect.bottom - rect.height * 0.15 });




  // Container
  const confettiContainer = document.createElement('div');
  confettiContainer.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    pointer-events: none;
    overflow: visible;
  `;
  document.body.appendChild(confettiContainer);

  // Simple confetti pieces from corners
  for (let i = 0; i < count; i++) {
    const piece = document.createElement('div');
    const isCircle = Math.random() > 0.5;
    const size = Math.random() * 8 + 4;
    
    // Random corner
    const startPoint = points[Math.floor(Math.random() * points.length)];
    
    // Random direction (outward from popup)
    const angle = Math.random() * 2 * Math.PI;
    const distance = Math.random() * 300 + 80;
    const tx = Math.cos(angle) * distance;
    const ty = Math.sin(angle) * distance - 100;

    const color = colors[Math.floor(Math.random() * colors.length)];
    const delay = Math.random() * 0.3;
    const rotate = Math.random() * 720 - 360;

    piece.style.cssText = `
      position: absolute;
      left: ${startPoint.x}px;
      top: ${startPoint.y}px;
      width: ${size}px;
      height: ${isCircle ? size : size * 1.5}px;
      background: ${color};
      border-radius: ${isCircle ? '50%' : '2px'};
      animation: sprinkle ${duration}ms ease-out ${delay}s forwards;
      --tx: ${tx}px;
      --ty: ${ty}px;
      --r: ${rotate}deg;
    `;
    confettiContainer.appendChild(piece);
  }

  const style = document.createElement('style');
  style.textContent = `
    @keyframes sprinkle {
      0% {
        transform: translate(0, 0) rotate(0deg) scale(1);
        opacity: 1;
      }
      100% {
        transform: translate(var(--tx), var(--ty)) rotate(var(--r)) scale(0.2);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);

  // Cleanup
  setTimeout(() => {
    if (confettiContainer.parentNode) document.body.removeChild(confettiContainer);
    if (style.parentNode) document.head.removeChild(style);
  }, duration + 500);
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/confettiUtils.ts